"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Outlook = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Outlook = function Outlook() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M16.877 10.816l7.06-4.76c0-.564-.525-.968-.822-.968h-8.06v4.695l1.641 1.033a.42.42 0 00.18 0z"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M17.018 12.563s-.254.155-.465 0l-1.497-1.028h-.001v6.38h7.606c.676 0 1.277-.394 1.277-1.333V7.953s-7.173 4.765-6.92 4.61zM7.067 14.586c.502 0 .9-.227 1.194-.679.294-.453.442-1.08.442-1.884 0-.838-.142-1.49-.428-1.955-.286-.465-.676-.698-1.172-.698-.51 0-.917.24-1.217.718-.3.48-.45 1.113-.45 1.902 0 .8.15 1.433.45 1.898.3.466.694.698 1.181.698z"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 21.07L13.972 24V0L0 2.704v18.367zM4.79 8.987c.592-.789 1.377-1.183 2.353-1.183.922 0 1.668.377 2.237 1.132.57.755.854 1.75.854 2.986.001 1.27-.294 2.294-.885 3.071-.59.777-1.36 1.167-2.31 1.167-.926 0-1.68-.377-2.262-1.13-.583-.753-.875-1.734-.875-2.944 0-1.277.296-2.31.888-3.099z"
  }));
};

exports.Outlook = Outlook;